"use client";

import { useState } from "react";

import { Details } from "@/components/audioPlayers/AudioPlayerDownloadConversionMulti/Details";
import { DoneConversionMulti } from "@/components/audioPlayers/AudioPlayerDownloadConversionMulti/DoneConversionMulti";
import { NotDoneConversionMulti } from "@/components/audioPlayers/AudioPlayerDownloadConversionMulti/NotDoneConversionMulti";
import {
  ConversionConstructedNoDates,
  MixedModelConstructedNoDates,
  ModelNoDates,
  UserNoDates,
} from "@/types/types";

export function AudioPlayerDownloadConversionMulti({
  conversionMulti,
  models,
  mixedModelsConstructed,
  user,
}: {
  conversionMulti: ConversionConstructedNoDates[];
  models: ModelNoDates[] | null;
  mixedModelsConstructed: MixedModelConstructedNoDates[] | null;
  user: UserNoDates;
}) {
  const [open, setOpen] = useState(false);

  const processedConversions = conversionMulti.every(
    (conversion) => conversion.confirmedDone || conversion.failed
  );

  return (
    <div className="rounded-3xl bg-white px-4 py-2 shadow-sm ring-1 ring-gray-900/5">
      {processedConversions && (
        <DoneConversionMulti
          conversionMulti={conversionMulti}
          models={models}
          mixedModelsConstructed={mixedModelsConstructed}
          open={open}
          setOpen={setOpen}
        />
      )}

      {!processedConversions && (
        <NotDoneConversionMulti
          conversionMulti={conversionMulti}
          open={open}
          setOpen={setOpen}
        />
      )}

      {open && (
        <Details
          conversionMulti={conversionMulti}
          models={models}
          user={user}
          mixedModelsConstructed={mixedModelsConstructed}
        />
      )}
    </div>
  );
}
